<template>

  <div class="Tranbox_box">
          <div class="Tranbox_boxl">
            <div class="Tranbox_title"><slot name="headers"></slot></div>
            <div class="Tranbox_num"><slot name="leftcon"></slot></div>
            <div class="Tranbox_tt"><slot name="lefttit"></slot></div>
          </div>
          <div class="Tranbox_boxr">
            <div class="Tranbox_rnum"><slot name="rightcon"></slot></div>
            <div class="Tranbox_time"><slot name="footers"></slot></div>
          </div>
    </div>
</template>

<script>
import { SearchKey } from "@/assets/server/api";
export default {

data() {
  return {
    value: "",
  };
},
methods: {
  search() {
    var inputvalue = document.getElementById("inputvalue");
    if (inputvalue.innerHTML == " ") {
      return;
    }
    if (this.value == "") {
      return;
    } else if (this.value != "") {
      this.$emit("search", this.value);
      const params = {
        key: this.value,
        pageNum: 1,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      SearchKey(formData).then((res) => {
        if (res.code == 200) {
          let type = res.result.type;
          switch (type) {
            case "1":
              let params1 = {
                address: this.value,
              };
              if (this.value == "") {
                return false;
              } else {
                this.$emit("search", params1);
                this.$router.push({
                  path: "/pc/BkHash",
                  query: {
                    query: this.value,
                  },
                });
              }

              break;
            case "2":
              let params2 = {
                txHash: this.value,
              };
              this.$emit("search", params2);
              this.$router.push({
                path: "/pc/To",
                query: {
                  txHash: this.value,
                },
              });
              break;
            case "3":
              let params = {
                blockHeight: res.result.blockHeight,
              };
              this.$emit("search", params);
              this.$router.push({
                path: "/pc/BkHeight",
                query: {
                  height: this.value,
                },
              });
              break;
          }
          this.value = "";
        } else if (res.code == 400) {
          this.$router.push({
            path: "/pc/404",
          });
        }
      });
    }
  },
},
};
</script>

<style lang="less" scoped>
.Tranbox_box {
      // width: 486px;
      // height: 131px;
      // background: #13161b;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      .Tranbox_boxl {
        // width: 100%;
        height: 100%;
        margin-top: 20px;
        margin-left: 20px;
        .Tranbox_title {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          height: 17px;
          line-height: 17px;
        }
        .Tranbox_num {
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #00e79a;
          margin-top: 8px;
          height: 35px;
          line-height: 35px;
          margin-bottom: 14px;
        }
        .Tranbox_tt {
          height: 17px;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 17px;
        }
      }
      .Tranbox_boxr {
        margin-right: 20px;
        margin-top: 45px;
        .Tranbox_rnum {
          height: 35px;
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #00e79a;
          line-height: 35px;
          margin-bottom: 14px;
        }
        .Tranbox_time {
          height: 17px;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 17px;
          text-align: right;
        }
      }
    }
</style>
